import { createFileRoute } from "@tanstack/react-router";
import {
  receivedLikeListQueryOptions,
  sentLikeListQueryOptions,
} from "~/features/likes/api";
import { LikeListTemplate } from "~/features/likes/LikeListTemplate";

export const Route = createFileRoute("/_authenticated/setting/likes")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(receivedLikeListQueryOptions),
      queryClient.ensureQueryData(sentLikeListQueryOptions),
    ]),
  component: LikeListTemplate,
});
